import { render, staticRenderFns } from "./profile-data.vue?vue&type=template&id=62db3b4c&scoped=true"
import script from "./profile-data.vue?vue&type=script&lang=js"
export * from "./profile-data.vue?vue&type=script&lang=js"
import style0 from "./profile-data.vue?vue&type=style&index=0&id=62db3b4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62db3b4c",
  null
  
)

export default component.exports